module.exports = __webpack_public_path__ + "static/img/charge.edef8f97.png";